<ng-container
  [caLocalizationScope]="LOCALIZATION_SCOPE"
  *ngrxLet="portfolioManagers | orderPortfolioManagers as portfolioManagers"
>
  <ng-container *ngIf="mobile; else desktop">
    <ng-container *ngIf="!openInDrawer; else mobileDrawerLink">
      <ng-container *ngFor="let contact of portfolioManagers; let last = last">
        <ng-container *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: contact }"></ng-container>
        <ng-container *ngIf="!last">, </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #mobileDrawerLink>
      <ng-container
        *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: portfolioManagers[0] }"
      ></ng-container>
      <span class="link link-primary ms-1" (click)="openProfileManagersDrawer()">
        {{ 'showAll' | caLocalize }}
      </span>
    </ng-template>
  </ng-container>

  <ng-template #desktop>
    <div class="d-flex">
      <ng-container
        *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: portfolioManagers[0] }"
      ></ng-container>
      <ng-container *ngIf="!openInDrawer; else drawerLink">
        <span
          *ngIf="portfolioManagers.length > 1"
          fMobilePopover
          [mobilePopoverTitle]="'portfolioManagers' | caLocalize"
          [ngbPopover]="popoverTemplate"
          [autoClose]="true"
          class="link link-primary ms-1"
          placement="bottom-right"
          data-automation-id="show-all-link"
        >
          {{ 'showAll' | caLocalize }}
        </span>
      </ng-container>
    </div>
  </ng-template>

  <ng-template #drawerLink>
    <span class="link link-primary ms-1" (click)="openProfileManagersDrawer()">
      {{ 'showAll' | caLocalize }}
    </span>
  </ng-template>

  <ng-template #popoverTemplate>
    <ul class="list-unstyled mb-0 ca-participant-popover">
      <li
        *ngFor="let contact of portfolioManagers"
        [caLocalizationScope]="LOCALIZATION_SCOPE"
        class="d-flex justify-content-between"
      >
        <ng-container *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: contact }"></ng-container>
      </li>
    </ul>
  </ng-template>

  <ng-template #profileLinkTemplate let-contact>
    <ca-profile-preview-link
      [text]="contact.name"
      [prId]="contact.id"
      [type]="'Contact'"
      class="link link-main pe-0 pe-sm-1 text-desktop-truncate"
      data-automation-id="single-contact-profile-link-preview"
    >
    </ca-profile-preview-link>
    <i
      *ngIf="contact?.isPrimary"
      [title]="'primaryContactTitle' | caLocalize"
      class="f-i f-i-sm f-i-crm-primary text-primary-600 align-bottom"
      [class.pe-4]="!mobile"
    ></i>
  </ng-template>
</ng-container>
